import { softDeleteCommercialEvaluation } from '@src/main/modules/reports/commercial/application/use-cases/soft-delete-commercial-evaluation.usecase';
import { createCommercialEvaluationHttpRepository } from '@src/main/modules/reports/commercial/infrastructure/repository/CommercialEvaluationHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useSoftDeleteCommercialEvaluation = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createCommercialEvaluationHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (evaluationId: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await softDeleteCommercialEvaluation(repository, evaluationId);
    },
  });
};
